import { Box } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

export default function ColumnChart() {
  const state = useSelector((store) => store.analyze);
  const { columnChartDataPrepared, selectedScenarioName, duration } = state;
  const { categories, values } = columnChartDataPrepared;

  const colorMapping = {
    TTM: "#0000FF",
    IMS: "#000000",
    MDR: "#964B00",
    "LE Diagnostics": "green",
    "Final Quota": "#FF9800",
    "Original Quota": "#F57C00",
    Month: "#800080",
  };

  // Function to get color based on category from the colorMapping
  const getColorForCategory = (categoryName, colorMapping) => {
    return colorMapping[categoryName] || "#0e0e0e"; // default color if category not found
  };

  const options = {
    chart: {
      id: "basic-bar",
    },
    title: {
      text: `${selectedScenarioName} Last ${duration} Months`,
      align: "left",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (value) => {
        const formatter = new Intl.NumberFormat("en-US");
        return formatter.format(value);
      },
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    fill: {
      opacity: 1,
    },
    xaxis: {
      categories: [...categories],
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right", // Aligns the legend to the right
      floating: true,
      offsetY: -10, // Adjusts vertical alignment if necessary
      offsetX: -5, // Adjusts horizontal alignment if necessary
    },
  };
  const series = [
    {
      name: "value",
      //data: [...values],
      data: categories.map((category, index) => ({
        x: category,
        y: values[index], // Replace with your actual y value
        fillColor: getColorForCategory(category, colorMapping),
      })),
    },
  ];

  return (
    <Box className={"columnChart"}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
        width={"95%"}
      />
    </Box>
  );
}
